import axios from 'axios'
import config from './config'
import endpoints from './endpoint'
import router from '../router'
import { Message } from 'element-ui'
import Qs from 'qs'

//axios实例
const axiosInstance = axios.create(config)
// let loadingInstance;
export const requestMethod = function(url, data, method) {
        let request = {
            method: method,
            url: url
        }
        if (method == 'post') {
            if (request.headers && request.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
                request.data = Qs.stringify(data);
            } else {
                request.data = JSON.stringify(data);
            }
        } else if (method == 'get') {
            request.params = data;
        } else{
            return config.baseURL+url;
        }
        return axiosInstance(request)
    }
    // 请求拦截
    axiosInstance.interceptors.request.use(function(config) {
        var token = localStorage.getItem('token')
            // loadingInstance = Loading.service({ fullscreen: true });
            config.headers.Authorization = token
            config.headers.AppKey= 'web'
            return config
        }, function(error) {
            return error
        })
    //返回拦截
    axiosInstance.interceptors.response.use(function(response) {
        // loadingInstance.close()
        // console.log('resp',response)
        if(response.data.result == 4){
            router.push({path:'/login'})
            Message.error(response.data.message)
        }
        if(response.data){
            return response.data;
        }
        if(response.datas){
            return response.datas;
        }

        }, function(error) {
           return error
        })

let VueAPI = {}

VueAPI.install = function(Vue) {

        Vue.prototype.$api = {}

        for (let key in endpoints) {
            //调用接口时，默认方式为'post', 如有需要，可在访问具体接口处，手动添加其他方式，如'get'
            Vue.prototype.$api[key] = function(data, method = 'post') {
                
                let url = endpoints[key]
                
                return requestMethod(url, data, method)
            }
        }
    }
    export default VueAPI